export const uploaderAction =
  "Click here to upload your photo\nOr drag and drop";
export const uploaderStep = "Upload your photo";

export const cropperAction = "Crop and position";
export const cropperStep = "Position your photo";

export const downloadAction = "Download your photo";
export const downloadStep = "All done!";
